// Dependecies
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { reject } from 'lodash';

// Store
import user from '../../store/user';
import company from '../../store/company';
import dateService from '../../store/dateService';

// Hooks
import useLanguage from '../useLanguage';

function useJobRequest() {
  const [disabledButton, useSetDisabledButton] = useState(false);
  const [nextModal, useSetNextModal] = useState(false);
  const [date, useSetDate] = useState();
  const history = useHistory();
  const [storeDate] = dateService();
  const { locale } = useLanguage();
  const [, companyActions] = company();
  const [userStore] = user();
  const [arrayDateDisabled, useSetArrayDateDisabled] = useState([]);
  const [month, useSetMonth] = useState(moment().format('MMMM'));

  const onPanelChange = (value) => {
    useSetDate(value);
    useSetMonth(moment(value).format('MMMM'));
  };

  const closeModal = (route) => {
    storeDate.dateRequest = date;
    const url = `/${locale}/${route}`;
    history.push(url);
  };

  useEffect(() => {
    if (userStore.token) {
      companyActions.getDates(userStore.token, locale).then(
        (res) => {
          useSetArrayDateDisabled(res.arrayDateDisabled);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
    }
  }, [userStore.token]);

  function disabledDate(current) {
    const array = arrayDateDisabled;
    let bol = false;

    array.forEach((element) => {
      bol = bol || moment(element).format('YYYY-MM-DD') === current.format('YYYY-MM-DD');
    });

    return (current && current < moment().startOf('day')) || bol;
  }

  function changeDisabledButton() {
    useSetDisabledButton(true);
  }
  function changeNextModal() {
    useSetNextModal(true);
  }
  function changeReturnModal() {
    useSetNextModal(false);
  }

  return {
    disabledDate,
    disabledButton,
    changeDisabledButton,
    changeNextModal,
    changeReturnModal,
    nextModal,
    onPanelChange,
    closeModal,
    month,
  };
}

export default useJobRequest;
